export default __webpack_public_path__ + "static/cookie-4c7fb3133f34fa996843b980a2c9738c.svg";